export const ReportsRoutes = [
    {
        "url": "/reporting{reportSlug: string}?location_ids&categories_positions&date_type&employee_status&from_date&pay_types&to_date&touchpoint_type&event_type&response_type&tab",
        "name": "appLayout.harriSH.reporting",
        "platformPage": true,
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/reports/reports.downgrade.module");
                }
            }
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['reports'],
        },
        "params": {
            location_ids: {
                dynamic: true,
            },
            categories_positions: {
                dynamic: true,
            },
            dateFilterType: {
                dynamic: true,
            },
            employee_status: {
                dynamic: true,
            },
            from_date: {
                dynamic: true,
            },
            pay_types: {
                dynamic: true,
            },
            to_date: {
                dynamic: true,
            },
            touchpoint_type: {
                dynamic: true,
            },
            event_type: {
                dynamic: true,
            },
            response_type: {
                dynamic: true,
            },
            tab: {
                dynamic: true,
            },
        },
    },
    {
        "url": "/rating-reports{reportSlug: string}?location_ids&categories_positions&date_type&employee_status&from_date&pay_types&to_date&touchpoint_type&event_type&response_type",
        "name": "appLayout.harriSH.engagement-ratings",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/reports/reports.downgrade.module");
                }
            }
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['reports'],
        },
        "params": {
            location_ids: {
                dynamic: true,
            },
            categories_positions: {
                dynamic: true,
            },
            dateFilterType: {
                dynamic: true,
            },
            employee_status: {
                dynamic: true,
            },
            from_date: {
                dynamic: true,
            },
            pay_types: {
                dynamic: true,
            },
            to_date: {
                dynamic: true,
            },
            touchpoint_type: {
                dynamic: true,
            },
            event_type: {
                dynamic: true,
            },
            response_type: {
                dynamic: true,
            },
        },
    },
    {
        "url": "/non-ratings-reports{reportSlug: string}?location_ids&categories_positions&date_type&employee_status&from_date&pay_types&to_date&touchpoint_type&event_type&response_type",
        "name": "appLayout.harriSH.engagement-non-ratings",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/reports/reports.downgrade.module");
                }
            }
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['reports'],
        },
        "params": {
            location_ids: {
                dynamic: true,
            },
            categories_positions: {
                dynamic: true,
            },
            dateFilterType: {
                dynamic: true,
            },
            employee_status: {
                dynamic: true,
            },
            from_date: {
                dynamic: true,
            },
            pay_types: {
                dynamic: true,
            },
            to_date: {
                dynamic: true,
            },
            touchpoint_type: {
                dynamic: true,
            },
            event_type: {
                dynamic: true,
            },
            response_type: {
                dynamic: true,
            },
        },
    },
    {
        "url": "/engagement-reports{reportSlug: string}?location_ids&categories_positions&date_type&employee_status&from_date&pay_types&to_date&touchpoint_type&event_type&response_type",
        "name": "appLayout.harriSH.surveys",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/reports/reports.downgrade.module");
                }
            }
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['reports'],
        },
        "params": {
            location_ids: {
                dynamic: true,
            },
            categories_positions: {
                dynamic: true,
            },
            dateFilterType: {
                dynamic: true,
            },
            employee_status: {
                dynamic: true,
            },
            from_date: {
                dynamic: true,
            },
            pay_types: {
                dynamic: true,
            },
            to_date: {
                dynamic: true,
            },
            touchpoint_type: {
                dynamic: true,
            },
            event_type: {
                dynamic: true,
            },
            response_type: {
                dynamic: true,
            },
        },
    },
    {
        "url": "/flash-report-v2",
        "name": "appLayout.schedule.reports.flash-report-v2",
        "showGlobalSearch": true,
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/reports/reports.downgrade.module");
                }
            },
        ],
    },
    {
        "url": "/no-pay-report",
        "name": "appLayout.schedule.reports.no-pay-report",
        "showGlobalSearch": true,
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/reports/reports.downgrade.module");
                }
            },
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['reports'],
        },
    },
    {
        "url": "/forecast-accuracy-report",
        "name": "appLayout.schedule.reports.forecast-accuracy-report",
        "showGlobalSearch": true,
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/reports/reports.downgrade.module");
                }
            },
            { path: "d3", type: "library", "name": "d3" },
            { path: "c3", type: "library", "name": "c3" }
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['reports'],
        },
    },
    {
        "url": "/engagement-non-ratings-report",
        "name": "appLayout.schedule.reports.engagement-non-ratings-report",
        "showGlobalSearch": true,
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/reports/reports.downgrade.module");
                }
            },
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['reports'],
        },
    },
    {
        "url": "/detailed-employee-labor-report",
        "name": "appLayout.schedule.reports.detailed-employee-labor-report",
        "showGlobalSearch": true,
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/reports/reports.downgrade.module");
                }
            },
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['reports'],
        },
    },
    {
        "url": "/engagement-ratings-report",
        "name": "appLayout.schedule.reports.engagement-ratings-report",
        "showGlobalSearch": true,
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/reports/reports.downgrade.module");
                }
            },
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['reports'],
        },
    }, {
        "url": "/schedule-publish-history-report",
        "name": "appLayout.schedule.reports.schedule-publish-history-report",
        "showGlobalSearch": true,
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/reports/reports.downgrade.module");
                }
            },
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['reports'],
        },
    },
    {
        "url": "/right-to-work-report",
        "name": "appLayout.schedule.reports.right-to-work-report",
        "showGlobalSearch": true,
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/reports/reports.downgrade.module");
                }
            },
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['reports'],
        },
    },
    {
        "url": "/unscheduled-employee-report",
        "name": "appLayout.schedule.reports.unscheduled-employee-report",
        "showGlobalSearch": true,
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/reports/reports.downgrade.module");
                }
            },
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['reports'],
        },
    },
    {
        "url": "/scheduling-status-report",
        "name": "appLayout.schedule.reports.scheduling-status",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/reports/reports.downgrade.module");
                }
            },
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['reports'],
        },
    },
    {
        "url": "/schedule-creation-metric-report",
        "name": "appLayout.schedule.reports.schedule-creation-metric",
        "showGlobalSearch": true,
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/reports/reports.downgrade.module");
                }
            },
            { path: "d3", type: "library", "name": "d3" },
            { path: "c3", type: "library", "name": "c3" }
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['reports'],
        },
    },
    {
        "url": "/time-sheets-report",
        "name": "appLayout.schedule.reports.time-sheet-report",
        "showGlobalSearch": true,
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/reports/reports.downgrade.module");
                }
            },
            { path: "d3", type: "library", "name": "d3" },
            { path: "c3", type: "library", "name": "c3" }
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['reports'],
        },
    },
    {
        "url": "/punch-reports?reportType&dateType&clockType&punchType&punchStatus&adjustmentType",
        "name": "appLayout.schedule.reports.punch-reports",
        "showGlobalSearch": true,
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/reports/reports.downgrade.module");
                }
            },
        ],
        "params": {
            reportType: {
                dynamic: true
            },
            dateType: {
                dynamic: true
            },
            clockType: {
                dynamic: true
            },
            punchType: {
                dynamic: true
            },
            punchStatus: {
                dynamic: true
            },
            adjustmentType: {
                dynamic: true
            },
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['reports'],
        },
    },
    {
        "url": "/consent-report",
        "name": "appLayout.schedule.reports.consent-report",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/reports/reports.downgrade.module");
                }
            },
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['reports'],
        },
    },
    {
        "url": "/turnover-report",
        "name": "appLayout.schedule.reports.turnover-report",
        "showGlobalSearch": true,
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/reports/reports.downgrade.module");
                }
            },
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['reports'],
        },
    },
    {
        "url": "/integration-rejection-report",
        "name": "appLayout.schedule.reports.integration-rejection-report",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/reports/reports.downgrade.module");
                }
            },
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['reports'],
        },
    },
    {
        "url": "/manager-schedule-report?from_date&to_date&auto_print&orientation",
        "name": "appLayout.schedule.reports.manager-schedule-report",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/reports/reports.downgrade.module");
                }
            },
        ],
        "params": {
            from_date: {
                dynamic: true
            },
            to_date: {
                dynamic: true
            },
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['reports'],
        },
    },
    {
        "url": "/regular-schedule-variation-report",
        "name": "appLayout.schedule.reports.regular-schedule-variation-report",
        "showGlobalSearch": true,
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/reports/reports.downgrade.module");
                }
            },
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['reports'],
        },
    },
    {
        "url": "/unemployment-claims-report",
        "name": "appLayout.schedule.reports.unemployment-claims-report",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/reports/reports.downgrade.module");
                }
            },
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['reports'],
        },
    },
    {
        "url": "/adp-employee-sync-status-report",
        "name": "appLayout.schedule.reports.adp-employee-sync-status-report",
        "showGlobalSearch": true,
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/reports/reports.downgrade.module");
                }
            },
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['reports'],
        },
    },
];
//# sourceMappingURL=reports.routes.js.map